import React, {useEffect, useState} from 'react';
import {CSSTransition} from 'react-transition-group';
import '../../stylesheets/reviewSlider.scss';

import starEmptyIcon from "../../resources/icons/star-empty.png";
import starFullIcon from "../../resources/icons/star-full.png";

const ReviewSlider = ({elements, intervalTime, cssTimeout}) => {
	const [ratingPos, setRatingPos] = useState(0);
	const [posA, setposA] = useState(0);
	const [posB, setposB] = useState(1);

  // Changeing the slider position
	const slideshow = () => {
    // The slider should run in a loop
    setRatingPos((ratingPos + 1) % elements.length);
    if(ratingPos % 2 === 1){
      setposA((posA + 2) % elements.length);
    }else{
      setposB((posB + 2) % elements.length);
    }
  }

	useEffect(() => {
    // Changing the slider position every intervalTime
    var t = setTimeout(slideshow, intervalTime);
    
    // Clean up after unmount;
    return () =>  {
      clearTimeout(t);
    };
	})

	return (
		<div className="rwWrapper">
			<CSSTransition
				classNames="rwReview"
				timeout={cssTimeout}
				in={ratingPos % 2 === 0}
				unmountOnExit
			>
				<RwReview review={elements[posA]}/>
			</CSSTransition>
			<CSSTransition
				classNames="rwReview"
				timeout={cssTimeout}
				in={ratingPos % 2 === 1}
				unmountOnExit
			>
				<RwReview review={elements[posB]}/>
			</CSSTransition>
		</div>
	)
};

const RwReview = ({review: {name, comment, rating}}) => {
  return (
    <div className="rwReview">
      <h1>{name}</h1>
      <p>"{comment}"</p>
      <div className="rwRating">
        { // Map over full stars
          [...Array(rating)].map((y,d) => 
            <img key={d} src={starFullIcon} alt="Stjerne"/>
          )
        }
        { // Map over empty stars
          [...Array((5 - rating))].map((y,d) => 
            <img key={d} src={starEmptyIcon} alt="Stjerne"/>
          )
        }
      </div>
    </div>
  );
};

export default ReviewSlider;


// WEBPACK FOOTER //
// ./src/components/reviewSlider/reviewSlider.js